import React from 'react';

const AboutClients = () => {
    return (
        <div id="clients" className="block spacer p-top-xl">
            <div className="bg-light-full-width clients-bottom-no-space">
                <div className="clients">
                    <div className="clients-items">
                        <div className="clients-item">
                            <div className="clients-item-content">
                                <img src="assets/img/demo/24_img.png" alt="Balkan" />
                            </div>
                        </div>

                        <div className="clients-item">
                            <div className="clients-item-content">
                                <img src="assets/img/demo/25_img.png" alt="Adveits" />
                            </div>
                        </div>

                        <div className="clients-item">
                            <div className="clients-item-content">
                                <img src="assets/img/demo/26_img.png" alt="Swiger" />
                            </div>
                        </div>

                        <div className="clients-item">
                            <div className="clients-item-content">
                                <img src="assets/img/demo/27_img.png" alt="The mandala community" />
                            </div>
                        </div>

                        <div className="clients-item">
                            <div className="clients-item-content">
                                <img src="assets/img/demo/24_img.png" alt="Balkan" />
                            </div>
                        </div>

                        <div className="clients-item">
                            <div className="clients-item-content">
                                <img src="assets/img/demo/25_img.png" alt="Adveits" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutClients;
